import { useFormDeliveryTimeField } from '@/features/pos/components/OrderFinalization/form'
import { useFormattedDateTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/formats/useFormattedDateTime'
import { useDeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useDeliveryTimeOffer'
import ErrorMessage from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/parts/ErrorMessage'
import Popover from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/parts/Popover'
import { fieldStyles } from '@/features/pos/components/OrderFinalization/parts/FormFields/styles'
import { DropdownContentWidth } from '@/features/ui/components/Dropdown/types'
import AcuteIcon from '@/features/ui/icons/components/AcuteIcon'
import DropdownControl from '@/features/ui/inputs/components/DropdownControl'
import { useMeasuredStyles } from '@/features/ui/inputs/components/ValidationStatusMessage/hooks'
import { useScreenSize } from '@/hooks/screen'
import { FC, useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface DeliveryTimeSelectorProps {
    contentWidth?: DropdownContentWidth
}

const DeliveryTimeSelector: FC<DeliveryTimeSelectorProps> = ({ contentWidth = 'anchor' }) => {
    const time = useFormDeliveryTimeField()

    const deliveryTimeOffer = useDeliveryTimeOffer()

    const [isOpen, setIsOpen] = useState(false)

    const toggleIsOpen = useCallback(() => setIsOpen((isOpen) => !isOpen), [])
    const close = useCallback(() => setIsOpen(false), [])

    const dateTime = useFormattedDateTime(time)

    const screenSize = useScreenSize()

    const wrapperRef = useRef<View>(null)
    const [measuredErrorMessageStyles, measureErrorMessageStyles] = useMeasuredStyles(wrapperRef)

    const { t } = useTranslation()

    return (
        <View onLayout={measureErrorMessageStyles} ref={wrapperRef}>
            <DropdownControl
                disabled={!deliveryTimeOffer}
                open={isOpen}
                label={t('pos.orderFinalization.inputs.deliveryTime.label')}
                placeholder=""
                value={dateTime}
                onToggleOpen={toggleIsOpen}
                FrontIcon={<AcuteIcon />}
                style={screenSize === 'small' && fieldStyles.smallScreenField}
                contentWidth={contentWidth}
            >
                {deliveryTimeOffer && (
                    <Popover open={isOpen} deliveryTimeOffer={deliveryTimeOffer} onClose={close} />
                )}
            </DropdownControl>
            <ErrorMessage measuredStyles={measuredErrorMessageStyles} />
        </View>
    )
}

export default DeliveryTimeSelector
